import SideBar from "../../components/AdminDashboard/SideBar";
import "../../styles/AdminDashboard/Settings.scss";
import ProfileImg from "../../images/Ellipse 57.png";
import {
  Box,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Modal,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import Resizer from "react-image-file-resizer";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useRef, useState } from "react";
import { deactivateUser, getUserInfo, updateAdminInfo, updatePassword } from "../../apis/General/users";
import { useDispatch, useSelector } from "react-redux";
import { deleteAdmin, getAdmins } from "../../apis/AdminDashboard/users";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Search from "../../components/AdminDashboard/Search";
import { link } from "fs";
import {  useLocation } from "react-router-dom";

const AdminPasswordAndSecurity = () => {
  const auth = useSelector((state) => state.auth);  

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [tab, setTab] = useState("account");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [images, setImages] = useState([]);

  const [admins, setAdmins] = useState([]);
  const mediaRef = useRef(null);


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const fetchUserInfo = async () => {
    setLoading(true)
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    // console.log('userDetails', response);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
    setEmail(response?.data?.message?.email);
    setLoading(false)

    
  };

  const fetchAdmins = async () => {
    const response = await getAdmins(auth?.token);
    console.log('getAdmins', response);
    setAdmins(response?.data?.message)
  }

  useEffect(() => {
    fetchUserInfo();
    fetchAdmins()
  }, []);

  const handleUpdatePassword = async(e) => {
    setLoading(true)
    e.preventDefault();
    if(newPassword === newPasswordConfirm) {
      const response = await updatePassword(oldPassword, newPassword, auth?.token);
    // console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success('Password updated successfully')
      setOldPassword("")
    setNewPassword("")
    setNewPasswordConfirm("")
    } else {
      toast.error(response?.data?.message)
    }
    
    } else {
      alert('Passwords do not match')
    }
    setLoading(false)

  }

  const handleDeleteUser = async () => {
    setLoading(true)
    const response = await deactivateUser(auth?.userInfo?.id, auth?.token);
    // console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
      dispatch({
        type: "LOGOUT_SUCCESS",
      });
      localStorage.removeItem("token");
      navigate("/login");
      window.scrollTo(0, 0);
    }else {
      toast.error(response?.data?.message)

    }
    setLoading(false)
  }

  const handleRemoveAdmin = async (id) => {
    setLoading(true);
    // console.log('id', id);
    const response = await deleteAdmin(id, auth?.token);
    console.log('response', response);
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
    }else {
      toast.error(response?.data?.message)

    }
    // console.log('response', response);
    setLoading(false)
  }
  const handleUpdateAdmin = async (e) => {
    setLoading(true);
    e.preventDefault()
    const response = await updateAdminInfo(firstName, lastName, email, "", auth?.token)
    if(response?.data?.statusCode === 200) {
      toast.success(response?.data?.message)
    }else {
      toast.error(response?.data?.message)

    }
    // console.log('response', response);
    setLoading(false)
  }

  const fileUpload = (e) => {
    setUploadLoading(true);

    let files = e.target.files;
    let allUploadedFiles = images;

    const fileToUri = (file, cb) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(null, reader.result);
      };
      reader.onerror = function (error) {
        cb(error, null);
      };
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        fileToUri(files[0], (err, result) => {
          if (result) {
            // console.log('mourinho', result);
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/open/v1/upload`,
                {
                  media_type: "image",
                  folder: "documents",
                  user_id: auth?.userInfo?.id,
                  contents: [result],
                },
                {
                  headers: {
                    Authorization: `Bearer ${auth ? auth.token : ""}`,
                  },
                }
              )
              .then((response) => {
                console.log('wenger', response);
                // if (response?.data?.body?.success === true) {
                //   if (documentTypeSent === "organizationBoundary") {
                //     setOrganizationBoundary(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "reportingBoundary") {
                //     setReportingBoundary(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "historicalInventory") {
                //     setHistoricalInventory(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "typeofFuel") {
                //     setTypeofFuel(response?.data?.body?.data[0]);
                //   } else if (
                //     documentTypeSent === "descriptionOfRenewableEnergySources"
                //   ) {
                //     setDescriptionOfRenewableEnergySources(
                //       response?.data?.body?.data[0]
                //     );
                //   } else if (documentTypeSent === "projectMonitoringReport") {
                //     setProjectMonitoringReport(response?.data?.body?.data[0]);
                //   } else if (documentTypeSent === "projectDescriptionReport") {
                //     setProjectDescriptionReport(response?.data?.body?.data[0]);
                //   } else {
                //     toast.error("document type not specified");
                //   }
                // }
                setUploadLoading(false);
              })
              .catch((err) => {
                setUploadLoading(false);
              });
          }
        });
      }
    }
  };


    const cards = [
    {
      icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9974 2.66797C8.6334 2.66797 2.66406 8.6373 2.66406 16.0013C2.66406 23.3653 8.6334 29.3346 15.9974 29.3346C23.3614 29.3346 29.3307 23.3653 29.3307 16.0013C29.3307 8.6373 23.3614 2.66797 15.9974 2.66797Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.69531 24.4613C5.69531 24.4613 8.66731 20.6667 16.0006 20.6667C23.334 20.6667 26.3073 24.4613 26.3073 24.4613M16.0006 16C17.0615 16 18.0789 15.5786 18.8291 14.8284C19.5792 14.0783 20.0006 13.0609 20.0006 12C20.0006 10.9391 19.5792 9.92172 18.8291 9.17157C18.0789 8.42143 17.0615 8 16.0006 8C14.9398 8 13.9224 8.42143 13.1722 9.17157C12.4221 9.92172 12.0006 10.9391 12.0006 12C12.0006 13.0609 12.4221 14.0783 13.1722 14.8284C13.9224 15.5786 14.9398 16 16.0006 16Z" stroke="#101828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
,
      title: "Profile",
      description: "Update your personal details and picture",
      border: "border-[#E5E5E5]",
      Links: "/admin/admin-profile",
          bg: "bg-[#FAFAFA]",


      // bg: "bg-white",
    },
    {
      icon:<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0026 22.6654C15.2954 22.6654 14.6171 22.3844 14.117 21.8843C13.6169 21.3842 13.3359 20.7059 13.3359 19.9987C13.3359 18.5187 14.5226 17.332 16.0026 17.332C16.7098 17.332 17.3881 17.613 17.8882 18.1131C18.3883 18.6132 18.6693 19.2915 18.6693 19.9987C18.6693 20.7059 18.3883 21.3842 17.8882 21.8843C17.3881 22.3844 16.7098 22.6654 16.0026 22.6654ZM24.0026 26.6654V13.332H8.0026V26.6654H24.0026ZM24.0026 10.6654C24.7098 10.6654 25.3881 10.9463 25.8882 11.4464C26.3883 11.9465 26.6693 12.6248 26.6693 13.332V26.6654C26.6693 27.3726 26.3883 28.0509 25.8882 28.551C25.3881 29.0511 24.7098 29.332 24.0026 29.332H8.0026C7.29536 29.332 6.61708 29.0511 6.11699 28.551C5.61689 28.0509 5.33594 27.3726 5.33594 26.6654V13.332C5.33594 11.852 6.5226 10.6654 8.0026 10.6654H9.33594V7.9987C9.33594 6.23059 10.0383 4.5349 11.2886 3.28465C12.5388 2.03441 14.2345 1.33203 16.0026 1.33203C16.8781 1.33203 17.745 1.50447 18.5538 1.8395C19.3627 2.17453 20.0976 2.6656 20.7167 3.28465C21.3357 3.90371 21.8268 4.63864 22.1618 5.44747C22.4968 6.25631 22.6693 7.12322 22.6693 7.9987V10.6654H24.0026ZM16.0026 3.9987C14.9417 3.9987 13.9243 4.42013 13.1742 5.17027C12.424 5.92042 12.0026 6.93783 12.0026 7.9987V10.6654H20.0026V7.9987C20.0026 6.93783 19.5812 5.92042 18.831 5.17027C18.0809 4.42013 17.0635 3.9987 16.0026 3.9987Z" fill="#101828" stroke="white" stroke-width="0.5"/>
</svg>
,
      title: "Password & Security",
      description: "See your password and update your password",
      border: "border-[#E5E5E5]",
      Links: "/admin/admin-password-and-security",
      bg: "bg-[#FAFAFA]",

    },
    {
      icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 5C15.4696 5 14.9609 5.21071 14.5858 5.58579C14.2107 5.96086 14 6.46957 14 7C14 7.53043 14.2107 8.03914 14.5858 8.41421C14.9609 8.78929 15.4696 9 16 9C16.5304 9 17.0391 8.78929 17.4142 8.41421C17.7893 8.03914 18 7.53043 18 7C18 6.46957 17.7893 5.96086 17.4142 5.58579C17.0391 5.21071 16.5304 5 16 5ZM12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3C17.0609 3 18.0783 3.42143 18.8284 4.17157C19.5786 4.92172 20 5.93913 20 7C20 8.06087 19.5786 9.07828 18.8284 9.82843C18.0783 10.5786 17.0609 11 16 11C14.9391 11 13.9217 10.5786 13.1716 9.82843C12.4214 9.07828 12 8.06087 12 7ZM25.5 6C25.1022 6 24.7206 6.15804 24.4393 6.43934C24.158 6.72064 24 7.10218 24 7.5C24 7.89782 24.158 8.27936 24.4393 8.56066C24.7206 8.84196 25.1022 9 25.5 9C25.8978 9 26.2794 8.84196 26.5607 8.56066C26.842 8.27936 27 7.89782 27 7.5C27 7.10218 26.842 6.72064 26.5607 6.43934C26.2794 6.15804 25.8978 6 25.5 6ZM22 7.5C22 7.04037 22.0905 6.58525 22.2664 6.16061C22.4423 5.73597 22.7001 5.35013 23.0251 5.02513C23.3501 4.70012 23.736 4.44231 24.1606 4.26642C24.5852 4.09053 25.0404 4 25.5 4C25.9596 4 26.4148 4.09053 26.8394 4.26642C27.264 4.44231 27.6499 4.70012 27.9749 5.02513C28.2999 5.35013 28.5577 5.73597 28.7336 6.16061C28.9095 6.58525 29 7.04037 29 7.5C29 8.42826 28.6313 9.3185 27.9749 9.97487C27.3185 10.6313 26.4283 11 25.5 11C24.5717 11 23.6815 10.6313 23.0251 9.97487C22.3687 9.3185 22 8.42826 22 7.5ZM5 7.5C5 7.10218 5.15804 6.72064 5.43934 6.43934C5.72064 6.15804 6.10218 6 6.5 6C6.89782 6 7.27936 6.15804 7.56066 6.43934C7.84196 6.72064 8 7.10218 8 7.5C8 7.89782 7.84196 8.27936 7.56066 8.56066C7.27936 8.84196 6.89782 9 6.5 9C6.10218 9 5.72064 8.84196 5.43934 8.56066C5.15804 8.27936 5 7.89782 5 7.5ZM6.5 4C5.57174 4 4.6815 4.36875 4.02513 5.02513C3.36875 5.6815 3 6.57174 3 7.5C3 8.42826 3.36875 9.3185 4.02513 9.97487C4.6815 10.6313 5.57174 11 6.5 11C7.42826 11 8.3185 10.6313 8.97487 9.97487C9.63125 9.3185 10 8.42826 10 7.5C10 6.57174 9.63125 5.6815 8.97487 5.02513C8.3185 4.36875 7.42826 4 6.5 4ZM8.651 24.505C8.19873 24.8031 7.67418 24.9732 7.13304 24.9972C6.59189 25.0212 6.05434 24.8983 5.57743 24.6414C5.10052 24.3846 4.70206 24.0034 4.42433 23.5383C4.1466 23.0733 3.99997 22.5417 4 22V15.5C4 15.3674 4.05268 15.2402 4.14645 15.1464C4.24022 15.0527 4.36739 15 4.5 15H8.531C8.62318 14.2681 8.91597 13.5759 9.377 13H4.5C3.83696 13 3.20107 13.2634 2.73223 13.7322C2.26339 14.2011 2 14.837 2 15.5V22C1.99974 22.8611 2.22186 23.7076 2.64484 24.4576C3.06782 25.2076 3.67732 25.8357 4.41431 26.281C5.15129 26.7263 5.99079 26.9737 6.85148 26.9993C7.71216 27.0249 8.56487 26.8277 9.327 26.427C9.01529 25.8201 8.78786 25.1734 8.651 24.505ZM22.673 26.427C23.4351 26.8277 24.2878 27.0249 25.1485 26.9993C26.0092 26.9737 26.8487 26.7263 27.5857 26.281C28.3227 25.8357 28.9322 25.2076 29.3552 24.4576C29.7781 23.7076 30.0003 22.8611 30 22V15.5C30 14.837 29.7366 14.2011 29.2678 13.7322C28.7989 13.2634 28.163 13 27.5 13H22.623C23.084 13.5759 23.3768 14.2681 23.469 15H27.5C27.6326 15 27.7598 15.0527 27.8536 15.1464C27.9473 15.2402 28 15.3674 28 15.5V22C28 22.5417 27.8534 23.0733 27.5757 23.5383C27.2979 24.0034 26.8995 24.3846 26.4226 24.6414C25.9457 24.8983 25.4081 25.0212 24.867 24.9972C24.3258 24.9732 23.8013 24.8031 23.349 24.505C23.2121 25.1734 22.9847 25.8201 22.673 26.427ZM12.5 13C11.837 13 11.2011 13.2634 10.7322 13.7322C10.2634 14.2011 10 14.837 10 15.5V23C10 24.5913 10.6321 26.1174 11.7574 27.2426C12.8826 28.3679 14.4087 29 16 29C17.5913 29 19.1174 28.3679 20.2426 27.2426C21.3679 26.1174 22 24.5913 22 23V15.5C22 14.837 21.7366 14.2011 21.2678 13.7322C20.7989 13.2634 20.163 13 19.5 13H12.5ZM12 15.5C12 15.3674 12.0527 15.2402 12.1464 15.1464C12.2402 15.0527 12.3674 15 12.5 15H19.5C19.6326 15 19.7598 15.0527 19.8536 15.1464C19.9473 15.2402 20 15.3674 20 15.5V23C20 24.0609 19.5786 25.0783 18.8284 25.8284C18.0783 26.5786 17.0609 27 16 27C14.9391 27 13.9217 26.5786 13.1716 25.8284C12.4214 25.0783 12 24.0609 12 23V15.5Z" fill="#101828"/>
</svg>
,
      title: "Team Access",
      description:
        "Control team accounts, assign roles, update details, and manage access securely.",
      border: "border-[#2C9963]",
      Links:"/admin/account-management-settings",
    //   bg: "bg-white",

      bg: "bg-[#FAFAFA]",
    },
  ];
    const location = useLocation();
  const isActive = location.pathname === cards.Links;

  return (
    <div className="admin_settings">
       <div className="sidebar_container">
        <SideBar />
      </div>


      <div className="main">
        <Search />
        {/* top bar */}
         <div className="absolute left-[218px] top-[78px] w-[1134px] flex flex-col gap-[30px]">
      {/* Header */}
     
    </div>

     <h2 className="text-[24px] font-semibold leading-[29px] text-[#101828] mb-8 mt-20">
        Settings
      </h2>

      {/* Cards Container */}
      <div className="flex gap-[33px]">
        {cards.map((card, idx) => (
        <div key={idx}>

        <Link to={card.Links}>
          <div
            
        className={`relative w-[356px] h-[167px] rounded-[12px] p-6 border 
          ${isActive ? card.bg : "border-[#E4E7EC]"}`}
          >
            
            {/* Icon */}
            <div className="absolute top-6 left-6">{card.icon}</div>

            {/* Text Content */}
            <div className="absolute left-6 top-[72px] flex flex-col gap-2 w-[314px]">
              <h3 className="text-[24px] font-medium leading-[29px] text-[#101828]">
                {card.title}
              </h3>
              <p className="text-[14px] leading-[17px] text-[#98A2B3]">
                {card.description}
              </p>
            </div>

          </div>
            </Link>
</div>
        ))}
      </div>

      {/* Admin's password and security */}
      <div className="relative w-[1134px] h-[857px]  mt-10 bottom-[-11px] border border-[#038B47] rounded-[24px] box-border">

  {/* Header */}
  <div className="absolute flex flex-row items-center justify-between w-[745px] h-[40px] left-[87px] top-[71px] gap-[368px]">
    <div className="flex flex-col gap-[6px] w-[129px]">
      <h2 className="text-[14px] font-semibold text-[#101828] leading-[17px]">Password</h2>
      <p className="text-[12px] text-[#98A2B3] leading-[15px]">Update your password</p>
    </div>
    <div className="flex gap-3">
        <Link
              to={"/admin/"}
              className="flex items-center gap-2 px-10 py-3 rounded-xl bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white text-[16px] font-semibold"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white"/>
</svg>
 Save  
            </Link>
      <button className=" px-10 py-3 rounded-lg text-[12px] border font-semibold bg-transparent text-transparent bg-clip-text 
        from-[rgba(0,102,51,0.4)] to-[rgba(2,164,204,0.4)] bg-gradient-to-r">
        Cancel
      </button>
    </div>
  </div>

  {/* Divider */}
  <div className="absolute left-[68.5px] top-[135px] w-[833.5px] border-t border-[#98A2B3]/50" />

  {/* Current Password */}
  <div className="absolute flex flex-col gap-3 w-[815px] left-[87px] top-[159px]">
    <label className="text-xs text-[#101828]">Current password</label>
    <div className="relative flex items-center w-[815px] h-[64px] px-6 border border-[#667185]/50 rounded-xl">
      <input
        type="password"
        placeholder="Paului2023"
        className="flex-1 text-xs text-[#667185] bg-transparent outline-none"
      />
      <svg
        className="w-6 h-6 text-[#667185] cursor-pointer"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeWidth="1.5" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </div>
  </div>

  {/* New Password */}
  <div className="absolute flex flex-col gap-3 w-[815px] left-[87px] top-[274px]">
    <label className="text-xs text-[#101828]">New password</label>
    <div className="relative flex items-center w-[815px] h-[64px] px-6 border border-[#667185]/50 rounded-xl">
      <input
        type="password"
        placeholder="NetUI2023"
        className="flex-1 text-xs text-[#667185] bg-transparent outline-none"
      />
      <svg className="w-6 h-6 text-[#667185]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeWidth="1.5" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </div>
  </div>

  {/* Confirm Password */}
  <div className="absolute flex flex-col gap-3 w-[815px] left-[87px] top-[389px]">
    <label className="text-xs text-[#101828]">Confirm password</label>
    <div className="relative flex items-center w-[815px] h-[64px] px-6 border border-[#667185]/50 rounded-xl">
      <input
        type="password"
        placeholder="NetUI2023"
        className="flex-1 text-xs text-[#667185] bg-transparent outline-none"
      />
      <svg className="w-6 h-6 text-[#667185]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeWidth="1.5" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </div>
  </div>

  {/* Divider */}
  <div className="absolute left-[68.5px] top-[504px] w-[833.5px] border-t border-[#98A2B3]/50" />

  {/* Switch Account Section */}
  <div className="absolute flex justify-between w-[805px] left-[87px] top-[536px]">
    <div>
      <h3 className="text-sm font-semibold text-[#101828]">Switch Account</h3>
      <p className="text-xs text-[#98A2B3]">
        Switch to closecarbon website admin
      </p>
    </div>
    <button className="px-10 py-3 rounded-lg text-[12px] font-semibold bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white">
      Switch
    </button>
  </div>

  {/* Divider */}
  <div className="absolute left-[69px] top-[608px] w-[833.5px] border-t border-[#98A2B3]/50" />

  {/* Delete Account Section */}
  <div className="absolute flex justify-between w-[805px] left-[87px] top-[640px]">
    <div>
      <h3 className="text-sm font-semibold text-[#D42620]">Delete My Account</h3>
      <p className="text-xs text-[#98A2B3]">
        Permanently delete the account and remove all access from all workspace
      </p>
    </div>
    <button className="px-10 py-3 rounded-lg text-sm font-semibold bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white">
      Delete
    </button>
  </div>
</div>

         


      

        
        
      </div>
    </div>
  );
};

export default AdminPasswordAndSecurity;
